import dropdownEvent from './base/_dropdownEvent';
import {children, focusable} from './base/_traverse';
import {afterTransition} from './base/_effects';
import Headroom from 'headroom.js';

class Navigation {
	constructor() {
		this.header = document.querySelector('.header');

		if (!this.header) {
			return;
		}

		this.opened = null;
		this.bodyThreshold = 10;
		this.activeItemClass = 'nav__menu-item--active';

		this.headerOpenedClass = 'header--open';
		this.searchOpenedClass = 'header--open-search';
		this.menuOpenedClass = 'header--open-menu';

		this.searchOpen = this.header.querySelector('.header__search-open');
		this.searchClose = this.header.querySelector('.header__search-close');
		this.searchForm = this.header.querySelector('.header__search-form');
		this.headerContent = this.header.querySelector('.header__content');
		this.height_cache = null; // Set within adjust_header_height_elements

		// click handler delegation
		this.header.addEventListener('click', (e) => {
			let {target} = e;

			while (target && target.parentNode) {
				// open the menu
				if (target.matches('.header__menu-toggle')) {
					return this.toggle('menu');
				}

				// open the search
				if (target.matches('.header__search-open')) {
					return this.open('search');
				}

				// close the search on desktop
				if (target.matches('.header__search-close')) {
					return this.close();
				}

				// toggle a submenu on mobile
				if (target.matches('.nav__menu-toggler')) {
					let tpn = target.parentNode;
					setTimeout((target) => {
						if (tpn.classList.contains('nav__menu-item--active') === true && tpn.classList.contains('first-time') === false) {
							//return tpn.classList.toggle(this.activeItemClass);
							return tpn.classList.toggle('first-time');
						} else {
							return tpn.classList.toggle(this.activeItemClass);
						}
					}, 10);

				}

				target = target.parentNode;
			}
		});

		// Event listeners for window changes on load, resize, and scroll to adjust header elements.
		window.addEventListener('DOMContentLoaded', (e) => {
			this.adjust_header_height_elements();
		});

		window.addEventListener('resize', (e) => {
			this.adjust_header_height_elements();
		});

		window.addEventListener('scroll', (e) => {
			this.adjust_header_height_elements();
		});

		const dropdownActivate = (e) => {
			const {target} = e;

			// dont bother with mobile or if it's already active
			if ('desktop' !== this.getMode() || target.classList.contains(this.activeItemClass)) {
				return;
			}

			target.classList.add(this.activeItemClass);

			const subMenu = children(target, '.nav__menu').shift();

			if (subMenu) {
				// prevent the menu from being offscreen
				let rect = subMenu.getBoundingClientRect();

				if (rect.left < this.bodyThreshold) {
					// off left
					subMenu.style.marginLeft = `${rect.left + this.bodyThreshold}px`;
				} else if (rect.right > document.body.clientWidth - this.bodyThreshold) {
					// off right
					subMenu.style.marginLeft = `${(rect.right - document.body.clientWidth + this.bodyThreshold) * -1}px`;
				}
			}
		}

		const dropdownDeactivate = (e) => {
			const {target} = e;

			// dont bother with mobile or if it's not active
			if ('desktop' !== this.getMode() || !target.classList.contains(this.activeItemClass)) {
				return;
			}

			target.classList.remove(this.activeItemClass);
			target.classList.remove('first-time');
			const subMenu = children(target, '.nav__menu').shift();

			if (subMenu) {
				subMenu.style.marginLeft = '';
			}
		}

		this.dropdowns = Array.from(this.header.querySelectorAll('.nav__menu-item--has-children')).map((node) => {
			node.addEventListener('dropdown:activate', dropdownActivate);
			node.addEventListener('dropdown:deactivate', dropdownDeactivate);
			return dropdownEvent(node);
		});




		// headroom variables
		if (!document.body.classList.contains('-static-header')) {
			const headroom = new Headroom(this.header, {
				offset: {
					up : 0,
					down : 0
				},
				tolerance: {
					up : 30,
					down : 30
				},
				// onPin: function () {
				// 	body.classList.remove('headroom-inactive');
				// 	console.log("Pinned");
				// },
				// onUnpin: function () {
				// 	body.classList.add('headroom-inactive');
				// },
				// onNotTop: function () {
				// 	body.classList.remove('search-open', 'search-opened');
				// }
			});
			headroom.init();
		}
	}

	getMode() {
		return window.matchMedia('(min-width: 960px)').matches ? 'desktop' : 'mobile';
	}

	open(which) {
		this.opened = which;
		this.header.classList.add(this.headerOpenedClass);

		if ('mobile' === this.getMode()) {
			document.body.style.overflow = 'hidden';
		}

		switch (which) {
			case 'menu':
				this.header.classList.add(this.menuOpenedClass);
				this.header.classList.remove(this.searchOpenedClass);
				break;
			case 'search':
				this.header.classList.add(this.searchOpenedClass);
				this.header.classList.remove(this.menuOpenedClass);
				afterTransition(this.header, () => focusable(this.searchForm));
				break;
		}
	}

	close() {
		this.opened = null;
		[this.headerOpenedClass, this.searchOpenedClass, this.menuOpenedClass].forEach(className => this.header.classList.remove(className));
		document.body.style.overflow = '';

		if (this.searchOpen) {
			this.searchOpen.focus();
		}
	}

	toggle(which = 'menu') {
		return this.opened === which ? this.close() : this.open(which);
	}

	/**
	 * Adjusts elements that are associated with the header's height dynamically, scroll, and on load.
	 */
	adjust_header_height_elements() {
		if (document.body.classList.contains('-static-header')) {
			return;
		}

		// Only adjust the element style values if the header height has changed.
		if (this.height_cache == this.header.offsetHeight) {
			return;
		} 

		let height = window.getComputedStyle(this.header).height,
			admin_height = null;

		// Check if the admin bar is present, and if it is, add the height to the header height for affected elements.
		if (document.querySelector('#wpadminbar')) {
			admin_height = `calc(${height} + ${window.getComputedStyle(document.querySelector('#wpadminbar')).height})`;
		}

		// Main Element, padding adjustment for fixed header
		if (document.querySelector('body > main')) {
			document.querySelector('body > main').style.paddingTop = height;
		}
		
		// In Page Navigation, top adjustment for fixed header
		if (document.querySelector('.in-page')) {
			document.querySelectorAll('.in-page').forEach(elem => {
				elem.style.top = admin_height ? admin_height : height;
			});
		}

		// Update the height cache value
		this.height_cache = height;
	}
}

export default Navigation;
